import styled from "styled-components";

export const SectionTag = styled.section`
	padding: 42px 0 100px;

	@media (min-width: 768px) {
		padding-top: 89px;
	}

	@media (min-width: 1280px) {
		padding: 59px 0 200px;
	}
`